module.exports = __webpack_public_path__ + "static/media/search.bf03fe8b.svg";